module.exports = __webpack_public_path__ + "img/bitget.ff5b555a.png";